module.exports = __webpack_public_path__ + "static/box_2-f35b621d513a272384a523aba75db5f0.png";